export class BenchmarkingTemplateConstants {
}
BenchmarkingTemplateConstants.SellerColumn = 'Seller';
BenchmarkingTemplateConstants.AttainmentColumn = 'Attainment';
BenchmarkingTemplateConstants.CostColumn = 'Cost';
BenchmarkingTemplateConstants.RevenueColumn = 'Revenue';
BenchmarkingTemplateConstants.GeographyColumn = 'Geography';
BenchmarkingTemplateConstants.BusinessUnitColumn = 'BusinessUnit';
BenchmarkingTemplateConstants.DateColumn = 'Date';
BenchmarkingTemplateConstants.GeographyInputColumn = 'GeographyInput';
BenchmarkingTemplateConstants.BusinessUnitInputColumn = 'BusinessUnitInput';
// Keep IDs
BenchmarkingTemplateConstants.BenchmarkDataElementID = 'hQIoNleHto8MQg';
BenchmarkingTemplateConstants.AdaptElementID = 'BkPHmeu0-qOKow';
BenchmarkingTemplateConstants.SelectColumnsElementID = 'IOwJDwSJJeyOlw';
BenchmarkingTemplateConstants.RenameInputColumnsElementID = '8gfuZvs9wOi6Hg';
BenchmarkingTemplateConstants.AddGeographyElementID = 'hmqZh_vKdQfxKQ';
BenchmarkingTemplateConstants.AddBusinessUnitElementID = 'wpz1HzjQ5rfctg';
BenchmarkingTemplateConstants.CurrentYearFilterElementID = 'I-MAfOb4Vr2gWQ';
BenchmarkingTemplateConstants.PreviousYearFilterElementID = 'VaXBbZxbVwUSbQ';
BenchmarkingTemplateConstants.CurrentFiscalYearElementID = 'RewyOjL8uBsm1Q';
BenchmarkingTemplateConstants.PreviousFiscalYearElementID = 'WpEpDlPXAJsUaw';
BenchmarkingTemplateConstants.OneColumnOneRowDataElementID = '7SZcXyZLCyk47g';
BenchmarkingTemplateConstants.GrowthValueElementID = 'NH23c4o1cXWIpQ';
BenchmarkingTemplateConstants.EfficiencyValueElementID = 'ishrim6QgpaXqw';
BenchmarkingTemplateConstants.AttainmentValueElementID = 'fJ-rejoFJmdKHw';
BenchmarkingTemplateConstants.DateValueElementID = 'ZOzNKEubu1jzVw';
BenchmarkingTemplateConstants.GeographyValueElementID = 'QpsJ9prOkC2xXg';
BenchmarkingTemplateConstants.BusinessUnitValueElementID = 'KZoP-vHU7e5aYQ';
BenchmarkingTemplateConstants.KeepIDs = [
    BenchmarkingTemplateConstants.BenchmarkDataElementID,
    BenchmarkingTemplateConstants.AdaptElementID,
    BenchmarkingTemplateConstants.SelectColumnsElementID,
    BenchmarkingTemplateConstants.RenameInputColumnsElementID,
    BenchmarkingTemplateConstants.AddGeographyElementID,
    BenchmarkingTemplateConstants.AddBusinessUnitElementID,
    BenchmarkingTemplateConstants.CurrentYearFilterElementID,
    BenchmarkingTemplateConstants.PreviousYearFilterElementID,
    BenchmarkingTemplateConstants.CurrentFiscalYearElementID,
    BenchmarkingTemplateConstants.PreviousFiscalYearElementID,
    BenchmarkingTemplateConstants.OneColumnOneRowDataElementID,
    BenchmarkingTemplateConstants.GrowthValueElementID,
    BenchmarkingTemplateConstants.EfficiencyValueElementID,
    BenchmarkingTemplateConstants.AttainmentValueElementID,
    BenchmarkingTemplateConstants.DateValueElementID,
    BenchmarkingTemplateConstants.GeographyValueElementID,
    BenchmarkingTemplateConstants.BusinessUnitValueElementID
];
BenchmarkingTemplateConstants.DateColumnName = 'Period';
BenchmarkingTemplateConstants.GrowthColumnName = 'Growth';
BenchmarkingTemplateConstants.EfficiencyColumnName = 'Efficiency';
BenchmarkingTemplateConstants.QuotaMetColumnName = 'QuotaMet';
BenchmarkingTemplateConstants.GrowthEfficiencyOutput = 'Growth vs Efficiency';
BenchmarkingTemplateConstants.MonthlyGrowthOutput = 'Growth by Month';
BenchmarkingTemplateConstants.BusinessUnitGrowthOutput = 'Growth by Business Unit';
BenchmarkingTemplateConstants.BusinessUnitEfficiencyOutput = 'Efficiency by Business Unit';
BenchmarkingTemplateConstants.BusinessUnitQuotaOutput = 'Attainment by Business Unit';
BenchmarkingTemplateConstants.GeographyGrowthOutput = 'Growth by Geography';
BenchmarkingTemplateConstants.GeographyEfficiencyOutput = 'Efficiency by Geography';
BenchmarkingTemplateConstants.GeographyQuotaOutput = 'Attainment by Geography';
BenchmarkingTemplateConstants.AverageGrowthOutput = 'Average Growth';
BenchmarkingTemplateConstants.AverageEfficiencyOutput = 'Average Efficiency';
BenchmarkingTemplateConstants.AverageQuotaOutput = 'Average Quota Met %';
BenchmarkingTemplateConstants.Ouputs = [
    BenchmarkingTemplateConstants.GrowthEfficiencyOutput,
    BenchmarkingTemplateConstants.MonthlyGrowthOutput,
    BenchmarkingTemplateConstants.BusinessUnitGrowthOutput,
    BenchmarkingTemplateConstants.BusinessUnitEfficiencyOutput,
    BenchmarkingTemplateConstants.BusinessUnitQuotaOutput,
    BenchmarkingTemplateConstants.GeographyGrowthOutput,
    BenchmarkingTemplateConstants.GeographyEfficiencyOutput,
    BenchmarkingTemplateConstants.GeographyQuotaOutput,
    BenchmarkingTemplateConstants.AverageGrowthOutput,
    BenchmarkingTemplateConstants.AverageEfficiencyOutput,
    BenchmarkingTemplateConstants.AverageQuotaOutput
];
//# sourceMappingURL=benchmarkingTemplateConstants.js.map